(() => {
  'use strict';
  if (window.__maxnewSustainabilityInit) { window.__maxnewSustainabilityInit(document); return; }
  function init(scope) {
    const roots = scope.matches?.('[data-mxs-page]') ? [scope] : scope.querySelectorAll('[data-mxs-page]');
    roots.forEach(root => {
      if (root.dataset.mxsBound) return;
      root.dataset.mxsBound = 'true';
      const cleanup = [];
      const listen = (target, event, fn) => { target.addEventListener(event, fn); cleanup.push(() => target.removeEventListener(event, fn)); };
      root.querySelectorAll('[data-mxs-card]').forEach(card => {
        const summary = card.querySelector('summary');
        const back = card.querySelector('[data-mxs-card-back]');
        const close = card.querySelector('[data-mxs-card-close]');
        if (!summary || !back || !close) return;
        let previous = card.open;
        const reflect = (focus) => {
          if (card.open) {
            back.hidden = false;
            if (focus) close.focus({preventScroll:true});
            summary.inert = true;
            summary.setAttribute('aria-hidden', 'true');
          } else {
            summary.inert = false;
            summary.removeAttribute('aria-hidden');
            if (focus) summary.focus({preventScroll:true});
            back.hidden = true;
          }
          previous = card.open;
        };
        card.dataset.mxsCardReady = 'true';
        close.hidden = false;
        reflect(false);
        listen(card, 'toggle', () => reflect(card.open !== previous));
        const dismiss = () => { card.open = false; reflect(true); };
        listen(close, 'click', event => { event.preventDefault(); dismiss(); });
        listen(card, 'keydown', event => {
          if (event.key !== 'Escape' || !card.open) return;
          event.preventDefault(); event.stopPropagation(); dismiss();
        });
        cleanup.push(() => {
          summary.inert = false; summary.removeAttribute('aria-hidden'); back.hidden = false;
          close.hidden = true; delete card.dataset.mxsCardReady;
        });
      });
      root.querySelectorAll('[data-mxs-film]').forEach(region => {
        const video = region.querySelector('video');
        const button = region.querySelector('[data-mxs-film-toggle]');
        const status = region.querySelector('[data-mxs-film-status]');
        if (!video || !button) return;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection;
        const limitedData = () => !!(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')));
        let visible = false, wantsPlay = !motion.matches && !limitedData(), failed = false;
        const label = region.dataset.mxsFilmLabel || 'film';
        video.autoplay = false;
        video.controls = false;
        button.hidden = false;
        const update = () => {
          button.innerHTML = '<span aria-hidden="true">' + (video.paused ? '▶' : 'Ⅱ') + '</span>';
          button.setAttribute('aria-label', (video.paused ? 'Play ' : 'Pause ') + label);
        };
        const sync = () => {
          if (failed) return;
          if (visible && !document.hidden && wantsPlay) video.play().then(update).catch(update);
          else video.pause();
        };
        listen(button, 'click', () => { wantsPlay = video.paused; visible = true; sync(); });
        listen(video, 'play', update);
        listen(video, 'pause', update);
        const mediaFailed = () => {
          failed = true; video.pause(); video.style.visibility = 'hidden'; button.hidden = true;
          if (status) status.hidden = false;
        };
        listen(video, 'error', mediaFailed);
        const source = video.querySelector('source');
        if (source) listen(source, 'error', mediaFailed);
        listen(document, 'visibilitychange', sync);
        const preferenceChanged = () => { wantsPlay = !motion.matches && !limitedData(); sync(); };
        listen(motion, 'change', preferenceChanged);
        if (connection?.addEventListener) listen(connection, 'change', preferenceChanged);
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15; sync(); }, {threshold:0.15});
          observer.observe(region); cleanup.push(() => observer.disconnect());
        }
        cleanup.push(() => video.pause());
        update();
      });
      root.querySelectorAll('[data-mxs-tabs]').forEach(group => {
        const nav = group.querySelector('nav');
        const tabs = Array.from(group.querySelectorAll('[data-mxs-tab]'));
        const panels = Array.from(group.querySelectorAll('[data-mxs-panel]'));
        if (!nav || tabs.length !== panels.length || !tabs.length) return;
        nav.setAttribute('role', 'tablist');
        tabs.forEach((tab, i) => {
          tab.id = panels[i].id + '-tab'; tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', panels[i].id);
          panels[i].setAttribute('role', 'tabpanel'); panels[i].setAttribute('aria-labelledby', tab.id); panels[i].tabIndex = 0;
        });
        const select = (index, focus) => {
          tabs.forEach((tab, i) => { const active = i === index; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; panels[i].hidden = !active; });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, i) => {
          listen(tab, 'click', event => { event.preventDefault(); select(i, false); });
          listen(tab, 'keydown', event => {
            let next = i;
            if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault(); select(next, true);
          });
        });
        const initial = panels.findIndex(panel => '#' + panel.id === window.location.hash);
        select(initial >= 0 ? initial : 0, false);
      });
      const container = root.closest('.shopify-section');
      if (container) container.addEventListener('shopify:section:unload', () => { cleanup.forEach(fn => fn()); delete root.dataset.mxsBound; }, {once:true});
    });
  }
  window.__maxnewSustainabilityInit = init;
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
